import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4 2.5h10A1.5 1.5 0 0115.5 4v6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.978 8.862c-.498-.365-.118-1.097.017-1.315-.243.268-.485.535-.674.827-.297.456-.425.957-.223 1.279.36.579 1.226.31 1.778.078L11 7.57 5.937 8.906c-.424.11-.765.096-.959-.044z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 12.5H3A1.5 1.5 0 011.5 11V6A1.5 1.5 0 013 4.5h9A1.5 1.5 0 0113.5 6v5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.467 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.01 1.24-.447.685-.638 1.436-.336 1.919.541.868 1.84.466 2.668.117l7.686-3.242-7.595 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 7.5h30c2.484 0 4.5 2.016 4.5 4.5v18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 26.586c-1.494-1.096-.354-3.292.05-3.946-.728.804-1.456 1.606-2.022 2.482-.892 1.368-1.274 2.87-.67 3.836 1.082 1.736 3.68.932 5.336.234L33 22.708l-15.188 4.01c-1.272.332-2.294.288-2.876-.132z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H9A4.502 4.502 0 014.5 33V18c0-2.484 2.016-4.5 4.5-4.5h27c2.484 0 4.5 2.016 4.5 4.5v15c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
export var Cards = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});